import React from "react";

const ProgressBarImport = () => {
    return (
        <div className="progress-bar-import">
            <div className="bar-progress-import"></div>
        </div>

    );
};

export default ProgressBarImport;
